export const setLocalStorageItem = (name: string, data: any) => {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(name, JSON.stringify(data));
  } catch {
    // ignore storage errors on SSR or quota exceed
  }
};

export const getFromLocalStorage = (name: string) => {
  if (typeof window === "undefined") return null;
  try {
    const data = localStorage.getItem(name);
    return data ? data : null;
  } catch {
    return null;
  }
};

export const getParsedDataFromLocalStorage = (name: string) => {
  if (typeof window === "undefined") return null;
  try {
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};
